export const INTIALIZE_DATASET = 'initialize_dataset';
export const REMOVE_DATASET = 'remove_dataset';
export const SET_PLOT = 'set_plot';
export const SET_SELECTION = 'set_selection';
